import u from 'umbrellajs/umbrella.esm.js';

export function initTabs() {
  u('.bsk-tabs .bsk-tab-btn').on('click', function () {
    const name = this.dataset.tab;

    const $this = u(this);
    const $root = $this.closest('.bsk-tabs-nav');
    if (!$root.length) return;

    $root.find('.bsk-tab-btn').attr('aria-selected', 'false');
    $this.attr('aria-selected', 'true');

    $root.find('.bsk-tab-contents > div').addClass('hidden');
    $root.find(`#${name}`).removeClass('hidden');
  });
}
